<template>
  <div class="field__mobile">
    <label
      class="label label--full"
      v-bind:for="`select--country-${id}`"
    >
      {{field.label.text}}
      <strong
        v-if="field.mandatory"
        class="field--required"
      >*</strong>
    </label>
    <div
      v-bind:id="`select--country-${id}`"
      class="select mobile__select"
    >
      <div
        v-bind:class="[
          'select__value',
          errors.has('mobile') ? 'is-invalid' : ''
        ]"
        v-on:click="toggleDropdown()"
      >
        {{mobile.country ? mobile.country : 'Country'}} <AngleDown class="icon-dropdown" />
      </div>
      <ul v-bind:class="{slect__dropdown: true, active: selecteToggle }">
        <li
          v-for="code in countryCode"
          v-bind:key="code.text"
          v-on:click="updateMobileCountry(code.code)"
          v-bind:class="[
            'select__option',
            mobile.country === code.code ? 'select__option--selected' : ''
          ]"
        >
          {{code.text}} {{code.code}}
        </li>
      </ul>
    </div>
    <input
      v-bind:class="[
        'field__input',
        'field__input--mobile',
        errors.has('mobile') ? 'is-invalid' : ''
      ]"
      v-bind:id="getFieldId(field.name)"
      v-bind:type="field.type"
      v-bind:name="field.name"
      v-bind:value="mobile.number"
      v-model="answer"
      v-on:change="updateMobileNumber()"
      v-bind:autocomplete="autocomplete"
    />
    <div
      class="is-danger error--mobile"
      v-show="errors.has('mobile')"
    >
      Please provide your country code and valid mobile number.
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import field from '@/components/mixin/field';
import AngleDown from '@/assets/icons/angle-down.svg';

export default {
  name: 'MobileField',
  mixins: [field],
  props: [
    'index',
    'field',
    'initial',
    'autocomplete',
  ],
  components: {
    AngleDown,
  },
  data() {
    return {
      mobileString: '',
      mobile: {
        country: '',
        number: '',
      },
      countryCode: [
        {
          text: 'AU',
          code: '+61',
        },
        {
          text: 'NZ',
          code: '+64',
        },
      ],
      selecteToggle: false,
    };
  },
  created() {
    if (!this.initial && field.value) {
      this.updateMobileField(field.value);
    }
  },
  mounted() {
    const self = this;
    const countrySelectId = `select--country-${self.id}`;

    document.addEventListener('click', (event) => {
      const flag = event.target.closest(`#${countrySelectId}`);

      if (flag) {
        // does nothing;
      } else {
        self.selecteToggle = false;
      }
    });
  },
  methods: {
    updateMobileField(value) {
      let number = value;

      if (value.indexOf('+') === 0) {
        number = value.substring(1);
      }

      const countryCode = number.substring(0, 2);

      if (countryCode === '61' || countryCode === '64') {
        this.mobile.country = countryCode;
        this.mobile.number = number.substring(2, number.length);
      } else {
        this.mobile.number = number;
      }

      console.log(this.mobile.number);

      // this.answer = this.mobile.number;
    },
    updateMobileString() {
      this.mobileString = `${this.mobile.country}${this.mobile.number}`;
      this.$emit('input', this.mobileString);
    },
    updateMobileCountry(value) {
      this.mobile.country = value;

      this.toggleDropdown();
      this.updateMobileString();
    },
    updateMobileNumber() {
      this.mobile.number = this.answer;

      this.updateMobileString();
    },
    toggleDropdown() {
      this.selecteToggle = !this.selecteToggle;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$field-width: 290px;
$field-mobile-gap: 8px;

$country-width: 100px;

.field__mobile {
  width: $field-width;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .icon-dropdown {
    margin-left: $field-mobile-gap;
  }
}

.label--full {
  width: 100%;
}

.mobile__select {
  width: $country-width;
  line-height: 28px;

  .select__value {
    padding-right: 15px;
    justify-content: space-between;
  }
}

input[type=text].field__input--mobile {
  width: calc(100% - #{$country-width + $field-mobile-gap});
}

.error--hide {
  input[type=text].is-invalid {
    border-color: #ddd;
  }

  .error--mobile {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.is-danger {
  flex: 0 0 auto;
}
</style>s
